import * as extendUtils from '../../../utils/object/extend.utils';
import {baseStagingConfig} from '../base';
import {PrismConfigOptions} from '../environment-variables.interface';
import {cnetStagingConfig} from './staging.config';

export const cnetAlphaConfig: PrismConfigOptions = extendUtils.deepExtend({}, [baseStagingConfig, cnetStagingConfig, {
  environmentName: "Cnet Alpha Environment",
  hubApi: "https://gcp-alpha-cms.cnet.com",
  ionicEnvName: 'alpha',
}]);



// WEBPACK FOOTER //
// ./src/app/environment-variables/cnet/alpha.config.ts